const getIndexIntro = () => {
    return `
    //INDEX:
    const CustomFilters = ({ oid, customFiltersToggled, customFiltersList, selectedCustomFilters, addCustomFilter, deleteCustomFilter, resetCustomFilters, context }) => {
    }
    export default CustomFilters;
    `;
}

export default getIndexIntro;
